import { z } from "zod";

export const merchantGroupSchema = z.enum([
  "SHELL",
  "BP",
  "ENI",
  "TOTAL_ENERGIES",
  "AVIA",
  "ESSO",
  "CASINO",
  "CARREFOUR",
  "INTERMARCHE",
  "AUCHAN",
  "SYSTEME_U",
  "LECLERC",
]);

export const merchantGroups = merchantGroupSchema.options;
export type MerchantGroup = z.infer<typeof merchantGroupSchema>;
